import { render, staticRenderFns } from "./ControlBoxInspectionList.vue?vue&type=template&id=661ba6d7&scoped=true&"
import script from "./ControlBoxInspectionList.vue?vue&type=script&lang=js&"
export * from "./ControlBoxInspectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ba6d7",
  null
  
)

export default component.exports